//userGroupId
export const STUDENT_GROUP_ID = 14;
export const TEACHER_GROUP_ID = 15;
export const FUNCTIONARY_GROUP_ID = 17;
export const PROFESSIONIST_GROUP_ID = 33;
